<form [formGroup]="form" class="package-selection" autocomplete="off">
  <h2>
    {{ 'movePackageModal.moveRequestTitle' | translate }}
    <button mat-dialog-close type="button" class="orms-close-button"></button>
  </h2>
  <p>
    {{ 'movePackageModal.selectDestination' | translate }}
    {{ data.packageName }}:
  </p>
  <div class="orms-label small">{{ 'movePackageModal.destination' | translate }} {{ nodeTitle }}</div>
  <div class="search-box">
    <ng-select
      class="package-search"
      [items]="packagesParentSubfunctions$ | async"
      bindLabel="displayName"
      [placeholder]="'movePackageModal.typeCodeOrName' | translate"
      [minTermLength]="2"
      formControlName="selectedFunction"
      [hideSelected]="true"
      [clearable]="false"
      [multiple]="false"
      [loading]="loading"
      [typeahead]="packagesParentSubfunctionsInput$"
    >
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label package-pill">{{ item.displayName }}</span>
        <span class="ng-value-icon right package-clear" (click)="clear(item)" aria-hidden="true">x</span>
      </ng-template>
    </ng-select>
  </div>
  <div class="label">{{ 'movePackageModal.justification' | translate }}</div>
  <div class="justification-section">
    <editor
      [init]="editorConfig"
      formControlName="justification"
      class="orms-editor"
      [class.is-invalid]="showInvalidState('justification')"
    ></editor>
  </div>
  <div class="orms-dialog-footer">
    <div class="orms-dialog-footer-actions">
      <button
        class="orms-button orms-button-primary submit-button"
        type="button"
        (click)="confirm()"
        [disabled]="this.form.invalid || submissionInProgress"
      >
        {{ 'general.submit' | translate }}
      </button>
      <button class="orms-button orms-button-secondary" type="button" mat-dialog-close>
        {{ 'general.cancel' | translate }}
      </button>
      <app-spinner [diameter]="26" *ngIf="submissionInProgress"></app-spinner>
    </div>
    <div class="approver">
      {{ 'changeRequest.approver' | translate }}:
      {{ form.get('selectedFunction').value?.manager || 'general.unassigned' | translate }}
    </div>
  </div>
</form>
